import React from 'react';

import {googleApiKey, isMobile} from "../../helpers/ApplicationHelper";

class ListingGoogleMapItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        let address = this.props.address;
        const isLightVersion = document.getElementsByClassName('light-listing').length > 0

        let mapSize = isMobile() ? '200x125' : `${isLightVersion ? '260' : '300'}x150`;
        return <div className='listing-map-item'>
                <a href={`http://maps.google.com/?q=${address.formatted_address}`} target="_blank">
                    <div className="map-wrapper">
                        <img
                            src={`https://maps.googleapis.com/maps/api/staticmap?center=${address.geometry.location.lat},${address.geometry.location.lng}&zoom=16&size=${mapSize}&scale=1&maptype=roadmap&markers=color:red%7Clabel:A%7C${address.geometry.location.lat},${address.geometry.location.lng}&key=${googleApiKey}`} />
                    </div>
                    <span className='address-line' dangerouslySetInnerHTML={{__html: address.formatted_address}}/>
                </a>
            </div>
    }

}

export default ListingGoogleMapItem;